import React, { SVGProps } from 'react'
const SvgHomescreenTopMetricsGrayscale = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={148}
    height={143}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#B3B7BE'}
      fillRule="evenodd"
      d="M31.888 13.613c-1.121-.6-2.605-.338-4.32.517a.407.407 0 0 0-.184.558.438.438 0 0 0 .579.177c1.66-.828 2.786-.915 3.508-.528s1.243 1.356 1.395 3.155c.013.151.111.284.256.345a.443.443 0 0 0 .436-.052c1.556-1.166 2.836-1.664 3.86-1.622.987.04 1.845.588 2.566 1.792a.439.439 0 0 0 .586.152.406.406 0 0 0 .158-.566c-.817-1.364-1.904-2.15-3.273-2.205-1.16-.048-2.438.435-3.819 1.364-.232-1.485-.779-2.568-1.748-3.087ZM48.761 3.375c-1.258-.673-2.922-.38-4.846.58a.456.456 0 0 0-.207.626.49.49 0 0 0 .65.199c1.862-.929 3.126-1.026 3.935-.593.81.434 1.395 1.521 1.566 3.54.015.17.125.318.287.387.162.069.35.046.49-.058 1.746-1.309 3.181-1.868 4.331-1.82 1.106.045 2.069.66 2.877 2.01a.492.492 0 0 0 .659.17.455.455 0 0 0 .176-.634c-.916-1.53-2.136-2.411-3.67-2.474-1.303-.054-2.737.488-4.286 1.53-.26-1.666-.874-2.88-1.962-3.463Z"
      clipRule="evenodd"
    />
    <g filter="url(#HomescreenTopMetricsGrayscale_svg__a)">
      <path
        fill={props.fill || '#697080'}
        d="M14 53.405a3.963 3.963 0 0 1 3.26-3.9l25.1-4.518a3.963 3.963 0 0 1 4.665 3.9v71.877H14v-67.36Z"
      />
      <path
        fill={props.fill || '#B3B7BE'}
        d="M14 57.368a3.963 3.963 0 0 1 3.26-3.9l25.1-4.518a3.963 3.963 0 0 1 4.665 3.9v71.877H17.963A3.963 3.963 0 0 1 14 120.764V57.368Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M41.925 68.507c0-.977-.791-1.768-1.768-1.768h-5.742a1.768 1.768 0 0 0 0 3.535h5.742c.977 0 1.768-.791 1.768-1.767ZM41.925 93.06c0-.977-.791-1.769-1.768-1.769h-5.742a1.768 1.768 0 0 0 0 3.536h5.742c.977 0 1.768-.792 1.768-1.768ZM41.925 117.611c0-.976-.791-1.767-1.768-1.767h-5.742a1.767 1.767 0 1 0 0 3.535h5.742c.977 0 1.768-.792 1.768-1.768Z"
        clipRule="evenodd"
        opacity={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M41.925 76.319c0-.977-.791-1.768-1.768-1.768h-5.742a1.768 1.768 0 0 0 0 3.535h5.742c.977 0 1.768-.791 1.768-1.767ZM41.925 100.871c0-.976-.791-1.767-1.768-1.767h-5.742a1.768 1.768 0 0 0 0 3.535h5.742c.977 0 1.768-.792 1.768-1.768ZM41.925 60.28c0-.977-.791-1.768-1.768-1.768h-5.742a1.768 1.768 0 0 0 0 3.535h5.742c.977 0 1.768-.791 1.768-1.767ZM41.925 84.832c0-.976-.791-1.768-1.768-1.768h-5.742a1.768 1.768 0 0 0 0 3.536h5.742c.977 0 1.768-.792 1.768-1.768ZM41.925 109.384c0-.976-.791-1.767-1.768-1.767h-5.742a1.767 1.767 0 1 0 0 3.535h5.742c.977 0 1.768-.791 1.768-1.768Z"
        clipRule="evenodd"
        opacity={0.25}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M28.56 68.507c0-.977-.79-1.768-1.767-1.768H21.05a1.768 1.768 0 0 0 0 3.535h5.743c.976 0 1.768-.791 1.768-1.767ZM28.56 93.06c0-.977-.79-1.769-1.767-1.769H21.05a1.768 1.768 0 0 0 0 3.536h5.743c.976 0 1.768-.792 1.768-1.768ZM28.56 117.611c0-.976-.79-1.767-1.767-1.767H21.05a1.767 1.767 0 1 0 0 3.535h5.743c.976 0 1.768-.792 1.768-1.768ZM28.56 76.319c0-.977-.79-1.768-1.767-1.768H21.05a1.768 1.768 0 0 0 0 3.535h5.743c.976 0 1.768-.791 1.768-1.767ZM28.56 100.871c0-.976-.79-1.767-1.767-1.767H21.05a1.768 1.768 0 0 0 0 3.535h5.743c.976 0 1.768-.792 1.768-1.768Z"
        clipRule="evenodd"
        opacity={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M28.56 60.28c0-.977-.79-1.768-1.767-1.768H21.05a1.768 1.768 0 0 0 0 3.535h5.743c.976 0 1.768-.791 1.768-1.767ZM28.56 84.832c0-.976-.79-1.768-1.767-1.768H21.05a1.768 1.768 0 0 0 0 3.536h5.743c.976 0 1.768-.792 1.768-1.768ZM28.56 109.384c0-.976-.79-1.767-1.767-1.767H21.05a1.767 1.767 0 1 0 0 3.535h5.743c.976 0 1.768-.791 1.768-1.768Z"
        clipRule="evenodd"
        opacity={0.25}
      />
    </g>
    <g filter="url(#HomescreenTopMetricsGrayscale_svg__b)">
      <path
        fill="#000"
        d="m47.698 35.86 45.214 5.656a3.535 3.535 0 0 1 3.096 3.476l.681 76.137a3.535 3.535 0 0 1-3.503 3.567h-48.76l-.707-85.294a3.54 3.54 0 0 1 3.98-3.543Z"
      />
      <g filter="url(#HomescreenTopMetricsGrayscale_svg__c)">
        <path
          fill={props.fill || '#697080'}
          d="m43.718 39.235 49.195 5.63c1.757.22 3.107 2.788 3.124 4.558l.65 71.706a3.535 3.535 0 0 1-3.501 3.568H44.425l-.706-85.462Z"
        />
      </g>
      <path
        fill="#EAEBF1"
        fillRule="evenodd"
        d="M67.813 104.609h2.95c1.952 0 3.535 1.5 3.535 3.35v16.744h-10.02v-16.744c0-1.85 1.583-3.35 3.535-3.35Z"
        clipRule="evenodd"
        opacity={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M82.65 53.052c1.095 0 1.982.888 1.982 1.982V67.78a1.982 1.982 0 0 1-3.963 0V55.034c0-1.094.887-1.982 1.981-1.982Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M69.29 53.052c1.094 0 1.981.888 1.981 1.982V67.78a1.982 1.982 0 0 1-3.963 0V55.034c0-1.094.887-1.982 1.982-1.982ZM82.65 77.605c1.095 0 1.982.887 1.982 1.981v12.746a1.982 1.982 0 0 1-3.963 0V79.586c0-1.094.887-1.981 1.981-1.981Z"
        clipRule="evenodd"
        opacity={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M69.29 77.605c1.094 0 1.981.887 1.981 1.981v12.746a1.981 1.981 0 1 1-3.963 0V79.586c0-1.094.887-1.981 1.982-1.981Z"
        clipRule="evenodd"
        opacity={0.25}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M55.93 77.605c1.094 0 1.98.887 1.98 1.981v12.746a1.981 1.981 0 1 1-3.962 0V79.586c0-1.094.887-1.981 1.981-1.981Z"
        clipRule="evenodd"
        opacity={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M82.65 102.157c1.095 0 1.982.887 1.982 1.981v8.282a1.982 1.982 0 1 1-3.963 0v-8.282c0-1.094.887-1.981 1.981-1.981Z"
        clipRule="evenodd"
        opacity={0.75}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M55.93 102.157c1.094 0 1.98.887 1.98 1.981v8.282a1.981 1.981 0 1 1-3.962 0v-8.282c0-1.094.887-1.981 1.981-1.981Z"
        clipRule="evenodd"
        opacity={0.2}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M55.93 53.052c1.094 0 1.98.888 1.98 1.982V67.78a1.982 1.982 0 0 1-3.962 0V55.034c0-1.094.887-1.982 1.981-1.982Z"
        clipRule="evenodd"
        opacity={0.5}
      />
    </g>
    <g filter="url(#HomescreenTopMetricsGrayscale_svg__d)">
      <path
        fill={props.fill || '#697080'}
        d="M87.976 66.154c0-2.501 2.288-4.377 4.74-3.886l38.309 7.662a3.963 3.963 0 0 1 3.185 3.885v46.949H87.976v-54.61Z"
      />
      <path
        fill={props.fill || '#B3B7BE'}
        d="M87.976 70.117c0-2.5 2.288-4.376 4.74-3.886l38.309 7.662a3.963 3.963 0 0 1 3.185 3.886v42.985a3.963 3.963 0 0 1-3.963 3.963h-42.27v-54.61Z"
      />
      <path
        fill="#F6F7FB"
        fillRule="evenodd"
        d="M107.644 112.648h7.402a3.535 3.535 0 0 1 3.535 3.535v8.741h-14.473v-8.741a3.536 3.536 0 0 1 3.536-3.535Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M96.776 100.96c0-.976.791-1.768 1.768-1.768h7.032a1.767 1.767 0 0 1 0 3.535h-7.032a1.767 1.767 0 0 1-1.768-1.767Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M96.776 90.387c0-.977.791-1.768 1.768-1.768h7.032a1.767 1.767 0 0 1 0 3.535h-7.032a1.768 1.768 0 0 1-1.768-1.767Z"
        clipRule="evenodd"
        opacity={0.36}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M96.776 79.813c0-.976.791-1.767 1.768-1.767h7.032a1.767 1.767 0 0 1 0 3.535h-7.032a1.768 1.768 0 0 1-1.768-1.768Z"
        clipRule="evenodd"
        opacity={0.56}
      />
      <path
        fill="#F6F7FB"
        fillRule="evenodd"
        d="M114.588 100.96c0-.976.792-1.768 1.768-1.768h7.032a1.767 1.767 0 0 1 0 3.535h-7.032a1.768 1.768 0 0 1-1.768-1.767Z"
        clipRule="evenodd"
        opacity={0.25}
      />
      <path
        fill="#F6F7FB"
        fillRule="evenodd"
        d="M114.588 90.387c0-.977.792-1.768 1.768-1.768h7.032a1.767 1.767 0 0 1 0 3.535h-7.032a1.768 1.768 0 0 1-1.768-1.767Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M114.588 79.813c0-.976.792-1.767 1.768-1.767h7.032a1.767 1.767 0 0 1 0 3.535h-7.032a1.768 1.768 0 0 1-1.768-1.768Z"
        clipRule="evenodd"
        opacity={0.5}
      />
    </g>
    <defs>
      <filter
        id="HomescreenTopMetricsGrayscale_svg__a"
        width={61.017}
        height={108.502}
        x={0.79}
        y={34.9}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3.963} />
        <feGaussianBlur stdDeviation={6.605} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.701961 0 0 0 0 0.717647 0 0 0 0 0.745098 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1173_483"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1173_483"
          result="shape"
        />
      </filter>
      <filter
        id="HomescreenTopMetricsGrayscale_svg__b"
        width={81.046}
        height={117.464}
        x={29.924}
        y={25.939}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3.963} />
        <feGaussianBlur stdDeviation={6.605} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.701961 0 0 0 0 0.717647 0 0 0 0 0.745098 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1173_483"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1173_483"
          result="shape"
        />
      </filter>
      <filter
        id="HomescreenTopMetricsGrayscale_svg__c"
        width={66.179}
        height={98.672}
        x={37.114}
        y={35.272}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2.642} />
        <feGaussianBlur stdDeviation={3.302} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1173_483"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1173_483"
          result="shape"
        />
      </filter>
      <filter
        id="HomescreenTopMetricsGrayscale_svg__d"
        width={75.584}
        height={91.972}
        x={73.626}
        y={51.431}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3.963} />
        <feGaussianBlur stdDeviation={6.605} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.501961 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1173_483"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1173_483"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default SvgHomescreenTopMetricsGrayscale
